import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-switchpay-version-two',
  templateUrl: './switchpay.component.html',
  styleUrls: ['./switchpay.component.scss']
})
export class SwitchpayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
